/**
 * SPDX-FileCopyrightText: (c) 2023 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

import {RightSidebarEmpty} from './RightSidebarEmpty';
import {RightSidebarObjectDefinitionDetails} from './RightSidebarObjectDefinitionDetails';
import {RightSidebarObjectFieldDetails} from './RightSidebarObjectFieldDetails';
import {RightSidebarObjectRelationshipDetails} from './RightSidebarObjectRelationshipDetails';
import {RightSideBarRoot} from './RightSidebarRoot';

export const RightSideBar = {
	Empty: RightSidebarEmpty,
	ObjectDefinitionDetails: RightSidebarObjectDefinitionDetails,
	ObjectFieldDetails: RightSidebarObjectFieldDetails,
	ObjectRelationshipDetails: RightSidebarObjectRelationshipDetails,
	Root: RightSideBarRoot,
};
